import { render, staticRenderFns } from "./DiNapoli.vue?vue&type=template&id=641a6a9e"
import script from "./DiNapoli.vue?vue&type=script&lang=js"
export * from "./DiNapoli.vue?vue&type=script&lang=js"
import style0 from "./DiNapoli.vue?vue&type=style&index=0&id=641a6a9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports